import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Pill } from './Pill';
import { heroBadges, heroImage, price, stats } from '../data/copy';
export function Hero() {
  return <header className="w-full bg-zinc-950" data-id="element-95" data-mp="9lv16qmocfvu">
      <div className="mx-auto max-w-4xl px-6 pb-10 pt-8 text-center sm:pt-10" data-id="element-96" data-mp="9ip7ey33opts">
        <Pill tone="gold" data-id="element-97" data-mp="4njqyesgw3d3">Per allenatori di atletica leggera</Pill>

        <h1 className="mx-auto mt-4 max-w-3xl font-serif text-[1.75rem] font-bold leading-[1.1] text-stone-100 sm:text-[2.75rem] lg:text-[3.4rem]" data-id="element-98" data-mp="129qs1epkbdkp">
          Pianifica l'intera stagione di atletica in{' '}
          <span className="text-yellow-500" data-id="element-99" data-mp="sa9slf0wlvx6">5 minuti</span>
        </h1>

        {/* El mockup va inmediatamente debajo de la promesa (el titular). */}
        <div className="relative mt-7" data-id="element-100" data-mp="nekqb3xi20x6">
          <div className="absolute inset-x-0 bottom-8 top-10 rounded-3xl bg-zinc-900" aria-hidden="true" data-id="element-101" data-mp="3d2lapfhgtb2a" />
          <img src={heroImage} alt="Atletica 360 completo: cofanetto con 6 volumi tecnici, tablet con il piano sessioni e i 5 bonus esclusivi." className="relative mx-auto w-full max-w-sm sm:max-w-xl lg:max-w-2xl" width={1240} height={1240} decoding="sync" loading="eager" {...{
          fetchpriority: 'high'
        }} data-id="element-102" data-mp="381e6fqej6u0d" />
        </div>

        <p className="mx-auto mt-4 max-w-prose font-sans text-sm leading-relaxed text-stone-400 sm:text-base" data-id="element-103" data-mp="39cfofaqx5jys">
          Il sistema digitale completo in PDF per allenatori di atletica
          leggera: 6 volumi tecnici, 70+ sessioni pronte all'uso e 5 bonus
          esclusivi.
        </p>

        <div className="mt-7" data-id="element-104" data-mp="35aucbrm7l9pn">
          <CtaButton size="large" className="w-full sm:w-auto" data-id="element-105" data-mp="2qk3mgp46gkp6">
            Accesso completo ora — {price}
          </CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-106" data-mp="2vjpvsngvxgsp">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1.5 font-sans text-[11px] text-stone-400 sm:text-xs" data-id="element-107" data-mp="2hjoytj3qqtii">
              <CheckIcon className="h-3.5 w-3.5 text-yellow-500" strokeWidth={2.6} aria-hidden="true" data-id="element-108" data-mp="2ljz6d076lrzh" />
              {badge}
            </li>)}
        </ul>
      </div>

      <div className="border-y border-zinc-800 bg-zinc-900" data-id="element-109" data-mp="na9yql90f8jc">
        <dl className="mx-auto grid max-w-6xl grid-cols-3 divide-x divide-zinc-800 px-6" data-id="element-110" data-mp="ic891hh2wayw">
          {stats.map(stat => <div key={stat.label} className="px-3 py-7 text-center" data-id="element-111" data-mp="ddnhe6fw6zm2">
              <dd className="font-serif text-4xl font-bold leading-none text-yellow-500 sm:text-5xl" data-id="element-112" data-mp="dbapb0gf78va">
                {stat.value}
              </dd>
              <dt className="mt-2 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-stone-400 sm:text-xs" data-id="element-113" data-mp="162udyzvsdf4o">
                {stat.label}
              </dt>
            </div>)}
        </dl>
      </div>
    </header>;
}